import { chowlyApi } from 'config'
import { generatePath } from 'react-router'
import client from '../chowly'
import { TypeName } from '../models'

export const updateMenuMappingItemCustomizationSortPosition = async ({
  id,
  customization_sort_position,
}: {
  id: string
  customization_sort_position: number
}) => {
  const url = generatePath(chowlyApi.menuMappingItemCustomization, { id })
  const payload = {
    data: {
      type: TypeName.MenuMappingItemCustomization,
      id,
      attributes: { customization_sort_position },
    },
  }
  const { data } = await client.patch(url, payload)
  return data
} 